import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, Output, computed, inject } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-video-pin',
    templateUrl: './video-pin.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconCustomComponent],
})
export class VideoPinComponent {
    private epcotConfig = inject(EpcotConfig);

    @HostBinding('class.pinned')
    @Input()
    isPinned: boolean;

    @HostBinding('class.video-pin')
    class = true;

    @HostBinding('class.disabled')
    @Input()
    disabled: boolean;

    @Output()
    toggle = new EventEmitter<void>();

    @HostListener('click')
    onClick(): void {
        if (!this.disabled) {
            this.toggle.emit();
        }
    }

    readonly isEpcotEnabled = computed(() => this.epcotConfig.isEnabled);
}
